import BaseModel, { type IResourceName } from 'volta/models/base-model';

import { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

export const ReportResourceName: IResourceName = {
  singular: 'report',
  plural: 'reports'
};

export default class Report extends BaseModel {
  @attr('string') declare name: string;
  @attr('string') declare projectName: string;
  @attr('string') declare workbookName: string;
  @attr('string') declare previewImageUrl: string;
  @attr('string') declare contentUrl: string;
  @attr('string') declare createdBy: string;
  @attr('string') embeddedUrl?: string;

  [Type] = 'report' as const;
}
